export const roomsActionTypes = {
  SET_ROOMS_LOADING: 'ROOMS/SET_ROOMS_LOADING',
  GET_ROOMS_REQUEST: 'ROOMS/GET_ROOMS_REQUEST',
  GET_ROOMS_SUCCESS: 'ROOMS/GET_ROOMS_SUCCESS',
  JOIN_ROOM_REQUEST: 'ROOMS/JOIN_ROOM_REQUEST',
  JOIN_ROOM_SUCCESS: 'ROOMS/JOIN_ROOM_SUCCESS',
  LEAVE_ROOM_REQUEST: 'ROOMS/LEAVE_ROOM_REQUEST',
  LEAVE_ROOM_SUCCESS: 'ROOMS/LEAVE_ROOM_SUCCESS',
  SET_PARTICIPANTS: 'ROOMS/SET_PARTICIPANTS',
  REMOVE_PARTICIPANT: 'ROOMS/REMOVE_PARTICIPANT',
  ADD_MESSAGE_REQUEST: 'ROOMS/ADD_MESSAGE_REQUEST',
  ADD_MESSAGE_SUCCESS: 'ROOMS/ADD_MESSAGE_SUCCESS',
  LEAVE_ROOM: 'ROOMS/LEAVE_ROOM',
  UNSUBSCRIBE_ROOM: 'ROOMS/UNSUBSCRIBE_ROOM',
  SUBSCRIBE_TO_ROOM: 'ROOMS/SUBSCRIBE_TO_ROOM',
} as const;

export type TRoom = {
  id: string;
  name: string;
  expertsCnt: number;
  membersCnt: number;
  messagesCnt: number;
  onlineCnt: number;
  public: boolean;
  img: any;
  order: number;
  isMember: boolean;
};

export type TMessage = {
  id: string;
  from: string;
  text: string;
  sender: string;
  stamp: string;
  attachment?: {
    id: string | null;
    type: string | null;
    size: string | null;
    name: string | null;
  };
};

export type TParticipant = {
  jid: string;
  nickname: string;
};

export type TRoomsState = {
  rooms: TRoom[];
  currentRoom: string | null;
  participants: TParticipant[];
  messages: TMessage[];
  loading: boolean;
  disabledSubmit: boolean;
};

type TJoinRoomSuccess = {
  type: typeof roomsActionTypes.JOIN_ROOM_SUCCESS;
  payload: {
    currentRoom: string;
    messages: TMessage[];
    disabledSubmit: boolean;
  };
};

type TSetParticipants = {
  type: typeof roomsActionTypes.SET_PARTICIPANTS;
  payload: TParticipant;
};

type TRemoveParticipant = {
  type: typeof roomsActionTypes.REMOVE_PARTICIPANT;
  payload: TParticipant;
};

type TAddMessageSuccess = {
  type: typeof roomsActionTypes.ADD_MESSAGE_SUCCESS;
  payload: TMessage[];
};

type TLeaveRoomSuccess = {
  type: typeof roomsActionTypes.LEAVE_ROOM_SUCCESS;
};

type TSetRooms = {
  type: typeof roomsActionTypes.GET_ROOMS_SUCCESS;
  payload: TRoom[];
};

type TSetRoomsLoading = {
  type: typeof roomsActionTypes.SET_ROOMS_LOADING;
  payload: boolean;
};

type TAddMessageRequestAction = {
  type: typeof roomsActionTypes.ADD_MESSAGE_REQUEST;
  payload: TMessage;
};

export type TSubscribeToRoomAction = {
  type: typeof roomsActionTypes.SUBSCRIBE_TO_ROOM;
  payload: { roomId: string };
};

export type TRoomsActions =
  | TSetParticipants
  | TRemoveParticipant
  | TAddMessageSuccess
  | TSetRooms
  | TJoinRoomSuccess
  | TSetRoomsLoading
  | TLeaveRoomSuccess
  | TAddMessageRequestAction
  | TSubscribeToRoomAction;
